import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPriority = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.00005 0.300049L7.35323 0.653228L13.3469 6.64687L13.7 7.00005L13.3469 7.35323L7.35323 13.3469L7.00005 13.7L6.64687 13.3469L0.653228 7.35323L0.300049 7.00005L0.653228 6.64687L6.64687 0.653228L7.00005 0.300049ZM1.71276 7.00005L7.00005 12.2873L12.2873 7.00005L7.00005 1.71276L1.71276 7.00005ZM6.50058 7.39958V4.20297H7.49952V7.39958H6.50058ZM7.7994 8.99788C7.7994 9.43924 7.4416 9.79703 7.00024 9.79703C6.55888 9.79703 6.20109 9.43924 6.20109 8.99788C6.20109 8.55652 6.55888 8.19873 7.00024 8.19873C7.4416 8.19873 7.7994 8.55652 7.7994 8.99788Z"
	})
});
export default SvgPriority;
